import type { Enums } from './db';

export type CountryCode = Enums<'country_code'>;
export type LocaleCode = Enums<'locale_code'>;
export type TradeDirection = Enums<'trade_direction'>;
export type CurrencyCode = Enums<'currency_code'>;
export type RequestStatus = Enums<'request_status'>;
export type OfferStatus = Enums<'offer_status'>;
export type OrderStatus = Enums<'order_status'>;
export type DisputeStatus = Enums<'dispute_status'>;
export type AdminRole = Enums<'admin_role'>;
export type MessageType = Enums<'message_type'>;
export type TranslationStatus = Enums<'translation_status'>;

export const COUNTRY_CODES = ['KR', 'JP'] as const satisfies readonly CountryCode[];
export const LOCALE_CODES = ['ko', 'ja'] as const satisfies readonly LocaleCode[];
export const TRADE_DIRECTIONS = ['KR_TO_JP', 'JP_TO_KR'] as const satisfies readonly TradeDirection[];
export const CURRENCY_CODES = ['KRW', 'JPY'] as const satisfies readonly CurrencyCode[];

export const ORDER_STATUSES = [
  'pending_payment',
  'paid',
  'shipped',
  'delivered',
  'confirmed',
  'settled',
  'cancelled',
  'refunded',
  'disputed',
] as const satisfies readonly OrderStatus[];

export const TRANSLATION_PROVIDERS = ['claude', 'vertex', 'openai', 'byteplus', 'deepl'] as const;
export type TranslationProviderId = (typeof TRANSLATION_PROVIDERS)[number];

/** 국가별 기본 통화/로케일 매핑 */
export const COUNTRY_CURRENCY: Record<CountryCode, CurrencyCode> = {
  KR: 'KRW',
  JP: 'JPY',
};
export const COUNTRY_LOCALE: Record<CountryCode, LocaleCode> = {
  KR: 'ko',
  JP: 'ja',
};
